import { render, staticRenderFns } from "./addTurntable.vue?vue&type=template&id=52485b06&scoped=true"
import script from "./addTurntable.vue?vue&type=script&lang=js"
export * from "./addTurntable.vue?vue&type=script&lang=js"
import style0 from "./addTurntable.vue?vue&type=style&index=0&id=52485b06&prod&lang=scss&scoped=true"
import style1 from "./addTurntable.vue?vue&type=style&index=1&id=52485b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52485b06",
  null
  
)

export default component.exports